/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';
import { replaceChatwootBranding } from 'shared/helpers/branding';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  const replaceInstallationName = text => {
    if (!text) return text;

    const installationName =
      globalConfig.value?.installationName || 'Joyprotyn';

    return replaceChatwootBranding(text).replace(
      /Joyprotyn/g,
      installationName
    );
  };

  return {
    replaceInstallationName,
  };
}
